import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@chakra-ui/react';

// Team section icons
const OverviewIcon = () => (
  <Icon viewBox="0 0 24 24" boxSize={4}>
    <path
      fill="currentColor"
      d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
    />
  </Icon>
);

const MembersIcon = () => (
  <Icon viewBox="0 0 24 24" boxSize={4}>
    <path
      fill="currentColor"
      d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-6c0-1.1.9-2 2-2s2 .9 2 2v6h8v-7.5c0-.83-.67-1.5-1.5-1.5S13 9.67 13 10.5V11H9V8.5C9 7.12 10.12 6 11.5 6S14 7.12 14 8.5V9h1v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V9c0-2.21-1.79-4-4-4-1.11 0-2.11.45-2.83 1.17C10.45 5.89 9.45 5.44 8.34 5.44 6.13 5.44 4.34 7.23 4.34 9.44V18z"
    />
  </Icon>
);

const InvitationsIcon = () => (
  <Icon viewBox="0 0 24 24" boxSize={4}>
    <path
      fill="currentColor"
      d="M20 6l-2.83-2.83c-.78-.78-2.05-.78-2.83 0L12 5.51 9.66 3.17c-.78-.78-2.05-.78-2.83 0L4 6l2.51 2.51L8.83 10 4 14.83 6.83 17.66 11.66 12.83 14.17 15.34 17 12.51 20 6z"
    />
  </Icon>
);

const RolesIcon = () => (
  <Icon viewBox="0 0 24 24" boxSize={4}>
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
    />
  </Icon>
);

const TeamRequestsIcon = () => (
  <Icon viewBox="0 0 24 24" boxSize={4}>
    <path
      fill="currentColor"
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    />
  </Icon>
);

const ContactsIcon = () => (
  <Icon viewBox="0 0 24 24" boxSize={4}>
    <path
      fill="currentColor"
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    />
  </Icon>
);

const AuditLogsIcon = () => (
  <Icon viewBox="0 0 24 24" boxSize={4}>
    <path
      fill="currentColor"
      d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
    />
  </Icon>
);

const TeamSettingsIcon = () => (
  <Icon viewBox="0 0 24 24" boxSize={4}>
    <path
      fill="currentColor"
      d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5a3.5,3.5 0 0,1 3.5,3.5a3.5,3.5 0 0,1 -3.5,3.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"
    />
  </Icon>
);

interface TeamSidebarManagerProps {
  activeSection: string;
  teamDetails: {
    permissions: {
      invite_user_to_team: boolean;
      update_team: boolean;
      manage_team_settings: boolean;
      view_team_members: boolean;
      view_team_audit_logs: boolean;
      list_team_contacts: boolean;
      add_team_contact: boolean;
      update_team_contact: boolean;
      delete_team_contact: boolean;
    };
    counters: {
      members_count: number;
      invitations_count: number;
      roles_count: number;
      membership_requests_count: number;
      role_requests_count: number;
      ownership_requests_count: number;
      contacts_count: number;
      audit_logs_count: number;
    };
  };
  onSectionChange: (section: string) => void;
  onInviteOpen: () => void;
  onEditOpen: () => void;
}

export const TeamSidebarManager: React.FC<TeamSidebarManagerProps> = ({
  activeSection,
  teamDetails,
  onSectionChange,
  onInviteOpen,
  onEditOpen,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!window.updateTeamSections || !teamDetails) return;

    // Create team navigation sections for third level left sidebar
    const teamSections = [
      {
        label: t('teams.overview'),
        icon: OverviewIcon,
        onClick: () => onSectionChange('overview'),
        isActive: activeSection === 'overview',
      },
      {
        label: t('teams.members'),
        icon: MembersIcon,
        onClick: () => onSectionChange('members'),
        isActive: activeSection === 'members',
        count: teamDetails.counters.members_count || 0,
      },
      {
        label: t('teams.invitations'),
        icon: InvitationsIcon,
        onClick: () => onSectionChange('invitations'),
        isActive: activeSection === 'invitations',
        count: teamDetails.counters.invitations_count || 0,
      },
      {
        label: t('teams.roles'),
        icon: RolesIcon,
        onClick: () => onSectionChange('roles'),
        isActive: activeSection === 'roles',
        count: teamDetails.counters.roles_count || 0,
      },
      {
        label: t('teams.requests'),
        icon: TeamRequestsIcon,
        onClick: () => onSectionChange('requests'),
        isActive: activeSection === 'requests',
        count: (teamDetails.counters.membership_requests_count || 0) + 
               (teamDetails.counters.role_requests_count || 0) + 
               (teamDetails.counters.ownership_requests_count || 0),
      },
      {
        label: t('teams.contacts'),
        icon: ContactsIcon,
        onClick: () => onSectionChange('contacts'),
        isActive: activeSection === 'contacts',
        count: teamDetails.counters.contacts_count || 0,
      },
      {
        label: t('teams.auditLogs'),
        icon: AuditLogsIcon,
        onClick: () => onSectionChange('audit-logs'),
        isActive: activeSection === 'audit-logs',
        count: teamDetails.counters.audit_logs_count || 0,
      },
      {
        label: t('teams.settings'),
        icon: TeamSettingsIcon,
        onClick: () => onSectionChange('settings'),
        isActive: activeSection === 'settings',
      },
    ];

    // Filter sections based on permissions
    const filteredSections = teamSections.filter(section => {
      switch (section.isActive ? activeSection : section.label) {
        case 'members':
        case t('teams.members'):
          return teamDetails.permissions.view_team_members;
        case 'audit-logs':
        case t('teams.auditLogs'):
          return teamDetails.permissions.view_team_audit_logs;
        case 'contacts':
        case t('teams.contacts'):
          return teamDetails.permissions.list_team_contacts;
        case 'settings':
        case t('teams.settings'):
          return teamDetails.permissions.manage_team_settings || teamDetails.permissions.update_team;
        default:
          return true; // overview, invitations, roles, requests are always visible
      }
    });

    // Update the third level sidebar
    window.updateTeamSections(filteredSections);

    // Setup floating action buttons based on current section and permissions
    const setupFloatingActions = () => {
      // You can add floating action buttons here if needed
      // For now, we'll use the existing pattern but might move to floating buttons later
      
      if (activeSection === 'members' && teamDetails.permissions.invite_user_to_team) {
        // Add invite user action - for now as a callback that can be triggered
        // In future iterations, this could be a floating action button
      }
      
      if (activeSection === 'settings' && teamDetails.permissions.update_team) {
        // Add edit team action
      }
    };

    setupFloatingActions();

    // Cleanup function
    return () => {
      if (window.updateTeamSections) {
        window.updateTeamSections([]);
      }
    };
  }, [activeSection, teamDetails, t, onSectionChange, onInviteOpen, onEditOpen]);

  return null; // This component only manages the sidebar, doesn't render anything
}; 